import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnDestroy, Output, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'fury-confirm-losing-changes-dialog',
  templateUrl: './confirm-losing-changes-dialog.component.html',
  styleUrls: ['./confirm-losing-changes-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class ConfirmLosingChangesDialogComponent implements AfterViewInit, OnDestroy {

  @Output() submitData: EventEmitter<boolean> = new EventEmitter<boolean>();
  private destroy$: Subject<null> = new Subject<null>();

  constructor(private cd: ChangeDetectorRef,
  ) {
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  submit(): void {
    this.submitData.next(true);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
